import { CircularProgress, Tab, Tabs } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { FixedSizeList } from 'react-window';

import CardTitle from '../../../components/CardTitle';
import Hyperlink from '../../../components/Hyperlink';
import arraySort from '../../../utils/array-sort';
import toObject from '../../../utils/to-object';
// import objectMap from '../../../utils/object-map'
// import pipe from '../../../utils/pipe'

const useStyles = makeStyles((theme) => ({
  list: {
    maxHeight: theme.spacing(48),
    overflowY: 'scroll',
    flexGrow: 1,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  tab: {
    textAlign: 'left',
  },
  mainCardContent: {
    display: 'flex',
    height: 400,
  },
}));

function InfluencerAudienceBrandAffinities(props) {
  const classes = useStyles();

  const [tab, setTab] = useState('Any');

  const handleTabChange = (e, value) => {
    setTab(value);
  };

  const fallbackImage = '../../fallback/img.png';

  const topBrands = arraySort(
    props.topBrands,
    (a, b) => b.percentage - a.percentage
  );

  const brandsByCategory = {
    Any: topBrands,
    ...toObject(
      ({ category }) => category,
      ({ category }) =>
        topBrands.filter(
          ({ main_category_label }) => category === main_category_label
        )
    )(props.topCategories.sort((a, b) => b.percentage - a.percentage)),
  };

  const categWithBrands = props.topCategories.filter(
    ({ category }) => brandsByCategory[category].length
  );

  return (
    <Card>
      <CardContent>
        <CardTitle>Audience brand affinities</CardTitle>
      </CardContent>
      <CardContent className={classes.mainCardContent}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={tab}
          onChange={handleTabChange}
          className={classes.tabs}
          indicatorColor="primary"
        >
          <Tab
            className={classes.tab}
            value="Any"
            label={<Box width="100%">Any</Box>}
          />
          {categWithBrands.map((category) => (
            <Tab
              className={classes.tab}
              key={category.category}
              value={category.category}
              label={
                <Box
                  display="flex"
                  width="100%"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {category.category}
                  <Box position="relative" width={48} height={48}>
                    <CircularProgress
                      style={{
                        border: '1px solid #bbb',
                        borderRadius: '50%',
                      }}
                      size={48}
                      variant="determinate"
                      value={Math.max(5, category.percentage)}
                    />
                    <Box
                      position="absolute"
                      fontSize="0.8rem"
                      fontWeight="bold"
                      top="50%"
                      left="50%"
                      style={{
                        transform: 'translateX(-50%) translateY(-50%)',
                      }}
                    >
                      {category.percentage.toFixed(1)}%
                    </Box>
                  </Box>
                </Box>
              }
            />
          ))}
        </Tabs>
        <List disablePadding className={classes.list}>
          <FixedSizeList
            itemSize={72}
            height={384}
            itemCount={brandsByCategory[tab] ? brandsByCategory[tab].length : 0}
          >
            {({ index, style }) => {
              const { brand, avatar_url, name, percentage } = brandsByCategory[
                tab
              ][index];

              return (
                <ListItem
                  key={name}
                  button
                  component={Hyperlink}
                  target="_blank"
                  href={`https://twitter.com/${brand}`}
                  style={style}
                >
                  <Box width="100%">
                    <Grid
                      container
                      justify="space-between"
                      alignItems="flex-end"
                    >
                      <Grid item>
                        <Grid container spacing={1} alignItems="center">
                          <Grid item>
                            <Avatar
                              src={avatar_url ? avatar_url : fallbackImage}
                              alt={name?.toUpperCase()}
                            />
                          </Grid>
                          <Grid item>
                            <Typography
                              variant="body1"
                              component="span"
                              display="block"
                            >
                              {name}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              component="span"
                              display="block"
                            >
                              @{brand}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item>
                        <Box fontSize="1.25rem" fontWeight="bold">
                          {percentage < 1 ? '< 1' : percentage.toFixed(1)}%
                        </Box>
                      </Grid>
                    </Grid>
                    <Box clone mt={1}>
                      <LinearProgress
                        variant="determinate"
                        value={percentage}
                      />
                    </Box>
                  </Box>
                </ListItem>
              );
            }}
          </FixedSizeList>
        </List>
      </CardContent>
    </Card>
  );
}

export default InfluencerAudienceBrandAffinities;
